import ObjectViewer from './ObjectViewer.component';

export default ObjectViewer;
